'use client';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body>
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Global Error Handler</h2>
          <p>Something went wrong at the application level!</p>
          <pre style={{ color: 'red' }}>{error.message}</pre>
          <button onClick={reset}>Try again</button>
        </div>
      </body>
    </html>
  );
}